/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import PlusIcon from 'assets/icons/icon-plus.svg';
import './ButtonPlus.scss';

const ButtonPlus = ({ label, onButtonClick }) => (
  <section className="button-plus" onClick={onButtonClick}>
    <div className="button-plus__el">
      <div className="button-plus__el__icon">
        <img src={PlusIcon} alt={label} />
      </div>
      {label && <small className="button-plus__el__label">{label}</small>}
    </div>
  </section>
);

ButtonPlus.propTypes = {
  /** button label */
  label: PropTypes.string,
  /** click event */
  onButtonClick: PropTypes.func,
};

ButtonPlus.defaultProps = {
  label: null,
  onButtonClick: () => {},
};

export default ButtonPlus;
